import { render } from "./DetailAccountForm.vue?vue&type=template&id=a55bdf70&scoped=true"
import script from "./DetailAccountForm.vue?vue&type=script&lang=js"
export * from "./DetailAccountForm.vue?vue&type=script&lang=js"

import "./DetailAccountForm.vue?vue&type=style&index=0&id=a55bdf70&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55bdf70"]])

export default __exports__